export enum GetActivitiesType {
    Activity = 1,
    Week = 2,
    Course = 3
}